import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { AvatarModule } from 'primeng/avatar';
import { TooltipModule } from 'primeng/tooltip';
import { FormsModule } from '@angular/forms';
import { InputTextModule } from 'primeng/inputtext';
import { ToastModule } from 'primeng/toast';
import { MessageService } from 'primeng/api';
import { RadioButtonModule } from 'primeng/radiobutton';
import { BreadcrumbModule } from 'primeng/breadcrumb';
import { ButtonModule } from 'primeng/button';
import { RippleModule } from 'primeng/ripple';
import { CalendarModule } from 'primeng/calendar';
import { UIModule } from '../core/ui/ui.module';
import { CheckboxModule } from 'primeng/checkbox';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { AppBreadcrumbComponent } from './atlantis/app.breadcrumb.component';
import { AppMenuitemComponent } from './atlantis/app.menuitem.component';
import { AppFooterComponent } from './atlantis/app.footer.component';
import { AppTopbarComponent } from './atlantis/app.topbar.component';
import { AppRightMenuComponent } from './atlantis/app.rightmenu.component';
import { AppMainComponent } from './atlantis/app.main.component';
import { AppConfigComponent } from './atlantis/app.config.component';
import { MenuService } from './atlantis/app.menu.service';
import { BreadcrumbService } from './atlantis/breadcrumb.service';
import { AppMenuComponent } from './atlantis/app.menu.component';
import { AppInlineMenuComponent } from './atlantis/app.inlinemenu.component';
import { TabViewModule } from 'primeng/tabview';
import { InputSwitchModule } from 'primeng/inputswitch';
import { LoadingComponent } from './loading/loading.component';
import { LoadingService } from '../domain/loading/loading.service';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { NgxLoadingModule } from 'ngx-loading';

@NgModule({
  declarations: [
    AppMainComponent,
    AppBreadcrumbComponent,
    AppConfigComponent,
    AppFooterComponent,
    AppMenuComponent,
    AppInlineMenuComponent,
    AppMenuitemComponent,
    AppTopbarComponent,
    AppRightMenuComponent,
    LoadingComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    UIModule,
    TranslateModule,
    AvatarModule,
    TooltipModule,
    FormsModule,
    InputTextModule,
    ToastModule,
    RadioButtonModule,
    BreadcrumbModule,
    ButtonModule,
    RippleModule,
    CalendarModule,
    CheckboxModule,
    ConfirmDialogModule,
    TabViewModule,
    InputSwitchModule,
    ProgressSpinnerModule,
    NgxLoadingModule.forRoot({
      fullScreenBackdrop: true
    })
  ],
  exports: [AppMainComponent],
  providers: [MessageService, MenuService, BreadcrumbService, LoadingService]
})
export class LayoutsModule {}
